document.addEventListener("DOMContentLoaded", function () {
  // Remove customizer bundle via AJAX
  document.addEventListener("click", function (e) {
    const target = e.target;
    if (!target || !target.classList.contains("js-remove-customizer-bundle")) return;
    e.preventDefault();

    const bundleElement = target.closest("[data-bundle-id]");
    if (!bundleElement) return;

    const bundleId = bundleElement.getAttribute("data-bundle-id");
    if (!bundleId) return;

    // Show removing text
    const removeText = target.textContent;
    target.textContent = "Removing...";
    target.disabled = true;

    // Fetch cart to find all line keys in this bundle
    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {
        const keysToRemove = cart.items
          .filter(item => item.properties && item.properties._bundle_id === bundleId)
          .map(item => ({ key: item.key, quantity: 0 }));

        if (!keysToRemove.length) {
          target.textContent = removeText;
          target.disabled = false;
          return;
        }

        // Build updates object
        const updates = keysToRemove.reduce((obj, i) => {
          obj[i.key] = i.quantity;
          return obj;
        }, {});

        // Send AJAX request to remove all items
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates })
        });
      })
      .then(res => res.json())
      .then(updatedCart => {
        // Update cart UI without page reload
        // Trigger cart:refresh for drawer or other scripts
        document.dispatchEvent(new CustomEvent("cart:refresh", { detail: updatedCart }));
    
        // Remove the bundle element from DOM
        bundleElement.remove();

        if (window.location.pathname === '/cart') {
          window.location.reload();
        }

      })
      .catch(err => {
        console.error("Error removing bundle:", err);
        target.textContent = removeText;
        target.disabled = false;
      });
  });
});
